import { createApp } from "vue";
import "./assets/main.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vSelect from "vue-select";
import ToastPlugin from "vue-toast-notification";
import "vue-toast-notification/dist/theme-bootstrap.css";
import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-dt";
import DashboardLayout from "./components/DashboardLayout.vue";
import FacilityAdminDashboardLayout from "./components/layouts/FacilityAdminDashboardLayout.vue";

const app = createApp(App);

app.component("default-layout", DashboardLayout);
app.component("facility-admin-layout", FacilityAdminDashboardLayout);
app.component("v-select", vSelect);

DataTable.use(DataTablesCore);
app.use(router);
app.use(store);
app.use(ToastPlugin, {
  // One of the options
  position: "top-right",
});

app.mount("#app");
